import { Server } from "miragejs";

export function routes(server: Server, token: string) {
  server.get("/time", () => new Date());

  server.passthrough();
}
